// extracted by mini-css-extract-plugin
export default {"surveyInputContainer":"surveyInputForm_surveyInputContainer__UuCaf","checkbox":"surveyInputForm_checkbox__yzIyt","surveyButton":"surveyInputForm_surveyButton__Uz6b6"};